module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.updateList), function(item, i) {
    return _c('radio-item', _vm._b({
      key: i,
      attrs: {
        "hasSubBottomBorder": i < _vm.updateList.length - 1,
        "isFullBorder": _vm.isFullBorder,
        "isShowBorder": _vm._isColmo ? true : _vm.isShowBorder,
        "isLast": i === _vm.updateList.length - 1
      },
      on: {
        "dofRadioItemChecked": function($event) {
          _vm.dofRadioItemChecked(i, $event)
        }
      }
    }, 'radio-item', item, false))
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-7d89fd6e!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio-list/index.vue
// module id = 639
// module chunks = 0 1